import Styles from "./styles.module.scss";
import { useCallback, useEffect, useMemo, useState } from "react";
// import JobSeakerDetail from "@Organism/Client/JobSeakerDetail";

import { Link, useNavigate } from "react-router-dom";
import { getListJobSeeker } from "@Services/client/jobSeeker";
import { capitalizedFirstLetter } from "@Helpers/capitalizedFirstLetter";
import Images from "@Theme/Images";
import JobSeekersCard from "@Molecule/JobSeekersCard";
import moment from "moment";
import { handleSubmit } from "@Helpers/getLinkJobPosting";
import useWindowSize from "@Hooks/useWindowSize";
import ModalWrapper from "@Atom/ModalWrapper";
import JobPostingLinkModal from "@Molecule/_modal/JobPostingLinkModal";
import Toast from "@Atom/Toast";
import {
  createCandidateBookmark,
  deleteCandidateBookmark,
} from "@Services/home";
import EmptyData from "@Organism/Recruiter/PipelineDetail/EmptyData";
import { fileBaseUrl } from "@Config/api";

export default function JobSeekerListHome({
  initialData,
  isLoadingData,
  setIsLoadingData,
}) {
  const [dataList, setDataList] = useState(initialData || null);
  const { width } = useWindowSize();
  const navigate = useNavigate();
  const allCategory = "🔥 Semua Pekerjaan";
  const [isLoadingBookmark, setIsLoadingBookmark] = useState(false);

  const [activeFilters, setActiveFilters] = useState({
    category: [allCategory],
  });

  const refetchData = useCallback(
    async (isLoading = true) => {
      try {
        setIsLoadingData(isLoading);
        const { response } = await getListJobSeeker(
          12,
          1,
          "",
          "",
          "",
          "",
          "",
          "",
          activeFilters.category[0] === allCategory
            ? ""
            : activeFilters.category
          // debouncedSearchTerm
        );

        setDataList(response);
        setIsLoadingData(false);
      } catch (err) {
        setIsLoadingData(false);
        console.log(err);
      }
    },
    [setIsLoadingData, activeFilters.category]
  );

  useEffect(() => {
    refetchData();
  }, [refetchData]);

  const data = useMemo(() => {
    return dataList?.data?.map((l) => ({
      id: l?._id,
      name: capitalizedFirstLetter(l?.title),
      experience: l?.experience,
      workType: l?.workType,
      contractType: l?.contractType,
      workMethod: l?.workMethod,
      client: l?.clientName,
      location: l?.placement,
      salary: l?.salary,
      createdAt: moment(l?.createdAt).startOf("day").fromNow(),
      status: l?.status,
      isRevision: "",
      img: l?.iconUri ? fileBaseUrl + l?.iconUri : Images.PERAMATA_LOGO_CICRLE,
      isShowButton: "",
      isApply: l?.isApply,
      isArchived: l?.isBookmarked,
      _id: l?._id, // for the <JobPostingLinkModal /> component
    }));
  }, [dataList?.data]);

  const jobFilterCategories = ["🔥 Semua Pekerjaan", ...dataList?.categories];

  const [isLoadingCopyLink, setIsLodingCopyLink] = useState(null);
  const [error, setError] = useState(null);
  const [showModalLink, setShowModalLink] = useState("");

  useEffect(() => {
    if (showModalLink) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.removeProperty("overflow");
    }
  }, [showModalLink]);

  const handleForm = (el) => {
    navigate(`/job-seeker/${el?._id}`);
  };

  const createArchiveJob = async (jobPostID) => {
    setIsLoadingBookmark(jobPostID);
    try {
      await createCandidateBookmark(jobPostID);
      refetchData(false);
    } catch (error) {
      console.log("Error create bookmark candidate", error);
    } finally {
      setIsLoadingBookmark(false);
    }
  };

  const deleteBookmark = async (jobPostID) => {
    setIsLoadingBookmark(jobPostID);
    try {
      await deleteCandidateBookmark(jobPostID);
      refetchData(false);
    } catch (error) {
      console.log("Error delete bookmark candidate", error);
    } finally {
      setIsLoadingBookmark(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (error) setError(false);
    }, 2000);
  }, [error]);

  const handleChangeFilter = (name, value) => {
    const temp = { ...activeFilters };

    if (temp[name].length >= 1 && value === allCategory) {
      temp[name] = [allCategory];
    }

    if (temp[name].includes(allCategory)) {
      temp[name] = temp[name].filter((c) => c !== allCategory);
    }

    if (temp[name].includes(value)) {
      temp[name] = temp[name].filter((el) => el !== value);
      if (temp[name].length === 0) {
        temp[name].push(allCategory);
      }
    } else {
      temp[name] = [...temp[name], value];
    }
    setActiveFilters(temp);
  };

  return (
    <div className={Styles.body}>
      <div className={Styles.topList}>
        <div className={Styles.titleListBox}>
          <span className={Styles.h1}>Daftar Pekerjaan</span>
          <span className={Styles.p}>
            Pilih pekerjaan yang sesuai untuk kariermu
          </span>
        </div>
      </div>

      <Toast
        isSent={error}
        label={"Job Posting Not Found"}
        bg="red"
        icon="cross-circle"
      />

      <section className={Styles.filteringJobs}>
        {jobFilterCategories.map((c, idx) => (
          <div
            key={idx}
            className={`${Styles.category} ${
              activeFilters["category"]?.includes(c) && Styles.active
            } `}
            onClick={() => handleChangeFilter("category", c)}
          >
            <span>{c}</span>
          </div>
        ))}
      </section>

      <div
        className={Styles.wrapperCards}
        style={
          data?.length === 0
            ? { minHeight: "400px", display: !isLoadingData ? "flex" : "grid" }
            : {}
        }
      >
        {data?.length === 0 && !isLoadingData ? (
          <div className={Styles.wrapEmptyHandler}>
            <EmptyData />
          </div>
        ) : (
          data?.map((el, idx) => {
            return (
              <JobSeekersCard
                key={idx}
                data={el}
                setShowDetail={() => handleForm(el)}
                loading={isLoadingCopyLink === el.id || isLoadingData}
                isLoadingBookmarkedIcon={isLoadingBookmark === el?.id}
                onClickArchiveIcon={() => {
                  if (!localStorage?.getItem("accessTokenUserLanding")) {
                    navigate("/user/login");
                  } else {
                    el?.isArchived
                      ? deleteBookmark(el?.id)
                      : createArchiveJob(el?.id);
                  }
                }}
              />
            );
          })
        )}
      </div>

      {showModalLink && (
        <ModalWrapper
          show={showModalLink}
          handleClose={() => setShowModalLink(null)}
          isLandingPage
        >
          <JobPostingLinkModal
            data={showModalLink}
            handleClose={() => setShowModalLink(null)}
          />
        </ModalWrapper>
      )}

      <div className={Styles.buttonBox}>
        <Link to={"/job-seeker"} className={Styles.textButton}>
          Lihat Pekerjaan Lainnya
        </Link>
      </div>
    </div>
  );
}
